import { useAppVersion } from "@/hooks/useAppVersion";

export const ReleaseBadge = ({ testId }) => {
  const version = useAppVersion();
  return (
    <span className="inline-flex shrink-0 flex-col items-center gap-1" data-testid={`${testId}-stack`}>
      <span className="release-alpha" data-testid={`${testId}-alpha`}>ALPHA</span>
      <span data-testid={testId} title="Playden version — see Patch Notes" className="font-mono text-[9px] sm:text-[10px] text-cyan-200 border border-purple-300/35 bg-purple-400/10 rounded-full px-2 py-0.5 whitespace-nowrap">V {version}</span>
    </span>
  );
};